export default __webpack_public_path__ + "static/media/sanmar15.dfe5270b.jpg";